import {
  BlockIdGenerator,
  Bold,
  BulletList,
  CodeInline,
  Color,
  ColorHighlighter,
  Heading,
  InlineEditorBulletList,
  InlineEditorListItem,
  InlineEditorOrderedList,
  InlineEditorParagraph,
  Italic,
  Link,
  ListItem,
  OrderedList,
  Strikethrough,
  Text,
  Underline,
} from '@lyearn/lygo-blocks';

export const meetingEditorExtensions = [
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Link,
  Color,
  ColorHighlighter,
  CodeInline,
  ListItem,
  OrderedList,
  BulletList,
  Text,
  InlineEditorBulletList,
  InlineEditorOrderedList,
  InlineEditorParagraph,
  InlineEditorListItem,
  BlockIdGenerator,
  Heading,
];
